import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CompanyApprovalPayload, CompanyApprovalRejectResponse } from '@edtech-ui/core/models/company-management/accept-reject-company-approval';
import { GetAllCompanyAdminListResponse } from '@edtech-ui/core/models/company-management/get-all-companies-list';
import { GetCompanyDetailsByIdResponse } from '@edtech-ui/core/models/company-management/get-companies-by-id-page';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class CompanyService {


	apiUrl = environment.companyApiUrl;

	constructor(private http: HttpClient) { }


	getAllCompaniesList(payload: {
		status?: string;
		search?: string;
		page?: number;
		limit?: number;
		created_at?: string;
		submitted_at?: string;
		industry?: string;
		date?: string;
	}): Observable<GetAllCompanyAdminListResponse> {

		let params = new HttpParams();

		if (payload.status) {
			params = params.set('status', payload.status);
		}

		if (payload.search) {
			params = params.set('search', payload.search);
		}
		if (payload.created_at) {
			params = params.set('created_at', payload.created_at);
		}
		if (payload.submitted_at) {
			params = params.set('submitted_at', payload.submitted_at);
		}
		if (payload.industry) {
			params = params.set('industry', payload.industry);
		}
		if (payload.date) {
			params = params.set('date', payload.date);
		}
		params = params.set('page', (payload.page || 1).toString());
		params = params.set('limit', (payload.limit || 20).toString());
		return this.http.get<GetAllCompanyAdminListResponse>(`${this.apiUrl}/admin/list`, { params });
	}


	getCompanyById(companyId: string): Observable<GetCompanyDetailsByIdResponse> {
		return this.http.get<GetCompanyDetailsByIdResponse>(`${this.apiUrl}/admin/${companyId}`);
	}


	postAcceptRejectCompanyApproval(payload: CompanyApprovalPayload, companyId: string): Observable<CompanyApprovalRejectResponse> {
		return this.http.post<CompanyApprovalRejectResponse>(`${this.apiUrl}/admin/${companyId}/action`, payload);
	}

	updateCompanyDetails(payload: any, companyId: string): Observable<any> {
		return this.http.put<any>(`${this.apiUrl}/admin/${companyId}`, payload)
	}

}
